import { useFetchDataFile, useGetColumnType } from "modules/data-files/api";

import { TimeSeriesProject } from "./interfaces";

import * as flowConfig from "./config";

export const getDataFileId = (project: TimeSeriesProject) => {
  const augmentedData = project.data_files[flowConfig.TS_FILE];
  const inputData = project.data_files[flowConfig.INPUT_DATA];
  return (
    (Array.isArray(augmentedData) ? augmentedData[0] : augmentedData) ||
    inputData
  );
};

export const getTimeColumn = (project: TimeSeriesProject) =>
  project.meta_data[flowConfig.TIMESTAMP_VAR];

export const useGetTimeIsDate = (project: TimeSeriesProject) => {
  const dataFileId = getDataFileId(project);
  useFetchDataFile(dataFileId, true);

  const colType = useGetColumnType(
    dataFileId,
    project.meta_data[flowConfig.TIMESTAMP_VAR]
  );

  return colType ? colType === "date" : true;
};
